import { render, staticRenderFns } from "./GrowthBenefitHistory.vue?vue&type=template&id=397de6de&scoped=true&"
import script from "./GrowthBenefitHistory.vue?vue&type=script&lang=js&"
export * from "./GrowthBenefitHistory.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/customerHome.css?vue&type=style&index=0&id=397de6de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397de6de",
  null
  
)

export default component.exports